import * as angular from 'angular';
import template from './counts.header.template.html';

function CountsHeaderDirective() {
    return {
        restrict: 'E',
        template: template,
        replace: true,
        scope: {
            navigationUrls: '=',
            countDisplayIntervalOptions: '=',
            countsInterval: '=',
            plant: '=plant',
            shop: '=shop',
        }
    };
}

export default angular.module('aps.directive.countsHeader', [])
    .directive('countsHeader', ['btnArray', CountsHeaderDirective])
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/counts/counts.header.directive.ts